import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './pages/Home'; 
import './App.css';
import './assets/css/style.css'; 
import './assets/css/common.css';  
import Topbar from './component/Topbar';
import Sidebar from './component/Sidebar';
import Login from './pages/Login';
import AddMedicine from './pages/Medicine/AddMedicine';
import AllMedicine from './pages/Medicine/AllMedicine';
import EditMedicine from './pages/Medicine/EditMedicine';
import AddInvoice from './pages/Invoice/AddInvoice';
import AllInvoice from './pages/Invoice/AllInvoice';
import EditInvoice from './pages/Invoice/EditInvoice';
import ReturnInvoice from './pages/Invoice/ReturnInvoice';
import InvoiceView from './pages/Invoice/InvoiceView';
import InvoiceReport from './pages/Report/InvoiceReport';
import MedicineReport from './pages/Report/MedicineReport';
import ReturnReport from './pages/Report/ReturnReport';
import MedicineStock from './pages/Medicine/MedicineStock';
import RevenueReport from './pages/Report/RevenueReport';
 

function App() {
  return (
    <Router>
      
  


      <Routes>
        <Route path="/" element={<Login />} />   
        <Route path="/dashboard" element={<Home />} />   
        <Route path="/add-medicine" element={<AddMedicine />} />   
        <Route path="/all-medicine" element={<AllMedicine />} />   
        <Route path="/edit-medicine/:id" element={<EditMedicine />} />   

        <Route path="/add-invoice" element={<AddInvoice />} />   
        <Route path="/all-invoice" element={<AllInvoice />} />   
        <Route path="/invoice/edit/:id" element={<EditInvoice />} />   
        <Route path="/invoice/:id/return" element={<ReturnInvoice />} />   

        <Route path="/invoice/:id" element={<InvoiceView />} />   
        <Route path="/invoice-report" element={<InvoiceReport />} />   
        <Route path="/medicine-report" element={<MedicineReport />} />   
        <Route path="/return-report" element={<ReturnReport />} />   
        <Route path="/stock-med" element={<MedicineStock />} />   
        <Route path="/revenue-report" element={<RevenueReport />} />   
        
 
 


      </Routes>
  
    </Router>
  );
}

export default App;
